import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFlipForward = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M10.8616 2.69526C11.122 2.43491 11.5441 2.43491 11.8044 2.69526L14.4711 5.36193C14.7314 5.62228 14.7314 6.04439 14.4711 6.30474L11.8044 8.9714C11.5441 9.23175 11.122 9.23175 10.8616 8.9714C10.6013 8.71106 10.6013 8.28895 10.8616 8.0286L12.3902 6.5H4.99967C3.71101 6.5 2.66634 7.54467 2.66634 8.83333C2.66634 10.122 3.71101 11.1667 4.99967 11.1667H7.99967C8.36786 11.1667 8.66634 11.4651 8.66634 11.8333C8.66634 12.2015 8.36786 12.5 7.99967 12.5H4.99967C2.97463 12.5 1.33301 10.8584 1.33301 8.83333C1.33301 6.80829 2.97463 5.16667 4.99967 5.16667H12.3902L10.8616 3.63807C10.6013 3.37772 10.6013 2.95561 10.8616 2.69526Z",
		fill: "currentColor"
	})
});
export default SvgFlipForward;
